import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { findRecord } from 'umg-ember-backend/data/builders/umg-rest';

export default class AdminSectionsSectionRoute extends Route {
  // Services
  @service breadcrumb;
  @service store;

  // Hooks
  async model({ section_id }) {
    const { content } = await this.store.request(
      findRecord('section', section_id),
    );

    return content.data;
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
